import api from './axios';
import type { Product } from '../types/product';

export interface BrandCategory {
  id: number;
  name: string;
  nameZh: string;
  nameCn: string;
  description: string;
  descriptionZh: string;
  descriptionCn: string;
  isActive: boolean;
  parentId: number | null;
  createdAt: string;
  imageUrl: string | null;
}

export interface BrandProductsResponse {
  products: Product[];
  total: number;
  page: number;
  limit: number;
  totalPages: number;
}

export interface BrandProductsParams {
  page?: number;
  limit?: number;
  categoryId?: number;
  sortBy?: 'new' | 'popular' | 'price_low' | 'price_high';
}

export const brandDetailsApi = {
  getBrandCategories: async (brandId: number): Promise<BrandCategory[]> => {
    try {
      const response = await api.get(`/api/brands/${brandId}/categories`);
      return response.data;
    } catch (error) {
      console.error('Error fetching brand categories:', error);
      return [];
    }
  },

  getBrandProducts: async (brandId: number, params: BrandProductsParams): Promise<BrandProductsResponse> => {
    try {
      const { page = 1, limit = 10, categoryId, sortBy = 'new' } = params;
      const response = await api.get(`/api/brands/${brandId}/products`, {
        params: {
          page,
          limit,
          categoryId,
          sortBy,
        },
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching brand products:', error);
      return {
        products: [],
        total: 0,
        page: 1,
        limit: 10,
        totalPages: 0,
      };
    }
  },
};
